/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import React from 'react';
import PropTypes from 'prop-types';
import { Space } from 'antd';
import { Card, CardBody, CardHeader, CardFooter } from 'reactstrap';

import Squares from './Squares';
import QuestionHeader from '../QuestionHeader';

function PuzzleWords({ data, userData, questionIndex = 0, ExplainText }) {
  // const reducer = React.useCallback((a, c) => ((a - c >= c.answer.length) ? a : c.answer.length), []);

  const answers = React.useMemo(() => data?.answers, [data?.answers]);
  // console.log("🚀 ~ file: index.js ~ line 13 ~ PuzzleWords ~ answers", answers)
  // const size = React.useMemo(() => answers.reduce(reducer, 0) + 1, [answers, reducer]);

  const [state, setState] = React.useState({
    selectedCells: [],
    isSubmitted: false,
    cells: [],
    correctedCells: [],
  });

  const renderAnswer = React.useCallback((answer, index) => {
    return (
      <div key={index}>
        <img src={answer.imageUrl} style={{ width: 150 }} alt='' />
      </div>
    );
  }, []);

  React.useEffect(() => {
    if (userData) {
      const { selectedCells, cells } = userData.answers;
      const correctedCells = [];
      cells.forEach((item, index) => {
        const arr = Object.values(item).map((x, i) => (x?.correct ? i : undefined)).filter(x => x !== undefined);
        arr.forEach(i => {
          correctedCells.push({
            position: {
              row: index,
              cell: i + 1,
            },
            correct: true,
          });
        });
      });
      setState(pre => ({ ...pre, selectedCells, correctedCells }));
    }
  }, [data, userData]);

  const receive = React.useCallback((cells) => {
    const max = data?.settings?.question?.columns ?? 8;
    if (state.cells.length === max) return;
    state.cells.push(cells);
    setState(pre => ({ ...pre, cells: state.cells }));
  }, [data?.settings?.question?.columns, state.cells]);

  const renderAnswerContent = React.useMemo(() => {
    return answers.map(renderAnswer);
  }, [answers, renderAnswer]);

  return (
    <Card className="m-0">
      <CardHeader>
        <QuestionHeader title={data.title} subTitle={data.subTitle} questionIndex={questionIndex} tooltip='PuzzleWords' />
      </CardHeader>
      <CardBody>
        <div className='d-flex flex-column align-items-center'>
          <div className='flex-1'>
            <Squares userData={userData?.answers?.cells} receive={receive} size={data?.settings?.question?.columns ?? 8} answers={answers} isSubmitted={state.isSubmitted} selectedCells={state.selectedCells} />
          </div>

          <div className='px-4'>
            <Space direction='horizontal' size='large'>
              {renderAnswerContent}
            </Space>
          </div>
        </div>
      </CardBody>
      {ExplainText}
      <CardFooter>
        <h3>Đáp án đúng</h3>
        <div style={{ textAlign: 'center' }}>
          <Squares userData={userData?.answers?.cells} receive={receive} size={data?.settings?.question?.columns ?? 8} answers={answers} isSubmitted={state.isSubmitted} selectedCells={state.correctedCells} />
        </div>
      </CardFooter>
    </Card>
  );
}

PuzzleWords.defaultProps = {
  userData: null,
};

PuzzleWords.propTypes = {
  // PropTypes
  data: PropTypes.instanceOf(Object).isRequired,
  userData: PropTypes.instanceOf(Object),
  questionIndex: PropTypes.number.isRequired,
};

export default PuzzleWords;
